<template>
  <modal-lg>
    <template v-slot:title>{{ $t("GlovoSettings") }}</template>

    <template v-slot:body>
      <b-row v-if="loading" class="text-center">
        <b-col>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">{{ $t("Loading") }}...</span>
          </div>
        </b-col>
      </b-row>

      <b-row v-else>
        <!-- Вибір Store Address -->
        <b-col cols="12" class="mb-3">
          <b-card>
            <h5 class="card-title text-decoration-underline mb-3">
              <b>{{ $t("GlovoStoreAddress") }}:</b>
            </h5>

            <!-- Перемикач середовища -->
            <b-form-group
              :label="$t('GlovoEnvironment')"
              label-for="environment-select"
              class="mb-3"
            >
              <b-form-radio-group
                id="environment-select"
                v-model="selectedEnvironment"
                :options="environmentOptions"
                @change="onEnvironmentChange"
                button-variant="outline-primary"
                buttons
              ></b-form-radio-group>
            </b-form-group>

            <b-form-group
              :label="$t('SelectStoreAddress')"
              label-for="store-address-select"
            >
              <b-form-select
                id="store-address-select"
                v-model="selectedStoreAddressId"
                :options="storeAddressOptions"
                @change="onStoreAddressChange"
              ></b-form-select>
            </b-form-group>

            <!-- Інформація про вибраний магазин -->
            <div v-if="selectedStoreInfo" class="mt-3 p-3 bg-light rounded">
              <p class="mb-1">
                <strong>{{ $t("GlovoStoreDetails") }}:</strong><br />
                <small class="text-muted">{{
                  selectedStoreInfo.details
                }}</small>
              </p>
              <p class="mb-0" v-if="selectedStoreInfo.lastMenuUploadDate">
                <strong>{{ $t("GlovoLastMenuSync") }}:</strong><br />
                <small class="text-muted">{{
                  selectedStoreInfo.lastMenuUploadDate
                }}</small>
              </p>
            </div>
          </b-card>
        </b-col>

        <!-- Управління меню -->
        <b-col
          cols="12"
          v-if="selectedStoreAddressId && this.perms[666] == true"
        >
          <b-card>
            <h5 class="card-title text-decoration-underline mb-3">
              <b>{{ $t("GlovoMenuManagement") }}:</b>
            </h5>
            <MenuManagement
              :storeAddressId="selectedStoreAddressId"
              :environment="selectedEnvironment"
            />
          </b-card>
        </b-col>
      </b-row>
    </template>

    <template v-slot:footer-bottom>
      <b-button variant="primary" @click="close">
        {{ $t("Close") }}
      </b-button>
    </template>
  </modal-lg>
</template>

<script>
import modalLg from "@/components/modal/modal-lg";
import MenuManagement from "./menuManagement.vue";
import { storeS } from "@/store"; // глобальне сховище даних

export default {
  props: ["objCard", "allApps"],
  components: { modalLg, MenuManagement },
  data() {
    return {
      form: {},
      loading: false,
      selectedStoreAddressId: null,
      storeAddresses: [],
      selectedEnvironment: "test", // 'test' або 'production'
    };
  },
  computed: {
    environmentOptions() {
      return [
        { text: this.$t("GlovoProductionEnv"), value: "production" },
        { text: this.$t("GlovoTestEnv"), value: "test" },
      ];
    },
    storeAddressOptions() {
      return [
        { value: null, text: this.$t("SelectStoreAddress") },
        ...this.storeAddresses.map((sa) => ({
          value: sa.id,
          text: `${sa.name} (ID: ${sa.id})`,
        })),
      ];
    },
    selectedStoreInfo() {
      return this.storeAddresses.find(
        (sa) => sa.id === this.selectedStoreAddressId
      );
    },
    perms() {
      /*
                Повертає дані прав доступу користувача з глобального стору.
            */
      return storeS.perms;
    },
  },
  async created() {
    this.form = this.allApps;
    console.log("Glovo data: ", this.form);
    await this.loadStoreAddresses();
  },
  methods: {
    async loadStoreAddresses() {
      try {
        this.loading = true;

        // Фільтруємо тільки Glovo додатки з appData
        const glovoApps = this.allApps.filter(
          (app) =>
            app.appName === "glovo" && app.appData && app.appData.storeAddressId
        );

        // Формуємо список адрес магазинів з наявних даних
        this.storeAddresses = glovoApps.map((app) => ({
          id: app.appData.storeAddressId,
          name: app.appData.storeName || "Unknown Store",
          details: app.appData.storeDetails || "",
          tradepointId: app.tradepointId,
          lastMenuUploadDate: app.appData.lastMenuUploadDate,
        }));

        // if (this.storeAddresses.length > 0) {
        //   this.selectedStoreAddressId = this.storeAddresses[0].id;
        // }
      } catch (error) {
        console.error("Error loading store addresses:", error);
        this.$toast.error(this.$t("ErrorLoadingData"));
      } finally {
        this.loading = false;
      }
    },
    onStoreAddressChange() {
      // Просто змінюємо вибраний магазин
    },
    onEnvironmentChange(newEnvironment) {
      // Передаємо зміну середовища в MenuManagement через prop
      this.$emit("environment-changed", newEnvironment);
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
